<app-kiosk-label-navbar (startOverButtonEmitter)="startOver()" (exitKioskButtonEmitter)="exitKiosk()" backButtonText="start over"
	locationText="{{ 'kiosk.printPumpLabels' | translate }}">
</app-kiosk-label-navbar>
<div class="flex-container">
	<div class="flex-item-patient-info">
		<app-patient-info [isToolbar]="false" [isHeaderVisible]="false" [isPatientDisplayed]="true"
			[patients]="currentPatient" [isKiosk]="true" [isSelectPatientButtonDisabled]="true"
			[hasSelectPatientButton]="false" [hasMultiplePatients]="false">
		</app-patient-info>
	</div>
</div>
<div class="flex-container">
	<div class="flex-item-patient-info">
		<div id="print-pump-select-number-labels-text">{{ 'kiosk.selectNumberOfLabels' | translate }}</div>
	</div>
</div>
<div class="kiosk-container-select-label">
	<ion-buttons slot="title">
		<div class="label-quantity-containers">
			@for (item of numbers ; track $index) {
			<app-kiosk-label-quantity class="kiosk-label-quantity" [item]=item.toString()
				(SelectQuantity)="handleTextChanged($event)"></app-kiosk-label-quantity>
			}
		</div>
	</ion-buttons>
</div>
	<div class="flex-container">
		<div class="flex-item-patient-info">
		<div id="select-number-labels-detail-text">{{ 'kiosk.numberOfLabels' | translate }}
		<div class="increment-container">
			<ion-button class="number-of-labels-increment-btn" style="margin-left: 100px;" color="white" (click)="decreaseAmount()">
				<fa-icon class="increment-icon" [icon]="faMinus" [fixedWidth]="true" size="1x"></fa-icon>
			</ion-button>
			<label id="label-quantity">{{labelQuantity}}</label>
			<ion-button class="number-of-labels-increment-btn" color="white" (click)="increaseAmount()">
				<fa-icon class="increment-icon" [icon]="faPlus" [fixedWidth]="true" size="1x"></fa-icon>
			</ion-button>
		</div>
		</div>
	</div>
	</div>
	<div class="kiosk-container-select-number-of-labels">
		<button id="print-btn" (click)="saveChanges()" [disabled]="labelQuantity < 1" expand="block">{{ 'kiosk.print' | translate }}</button>
	</div>


<ion-modal trigger="print-btn" (willDismiss)="onWillDismiss($event)">
	<ng-template>
		<ion-content class="ion-padding">
			<div class="flex-container">
				<div class="modal-confirm-header-container">
					<label id="modal-confirm-header-text">{{ 'kiosk.isThisCorrect' | translate }}</label>
				</div>
				<div class="modal-flex-item-patient-info">
					<app-kiosk-print-label [patients]="currentPatient" [milkBottles]="createdMilks"
						[selectedPrinter]="printer" (selectPrinterPress)="handleSelectPrinterPressed()"
						(printed)="printed()" [labelQuantity]="labelQuantity" (cancelModal)="cancelPrint()">
					</app-kiosk-print-label>
				</div>
			</div>
		</ion-content>
	</ng-template>
</ion-modal>
